export enum UserStatus {
  ACTIVE = 'ACTIVE',
  PASSIVE = 'PASSIVE',
  PENDING = 'PENDING',
  DELETED = 'DELETED'
}
